import React from 'react'
import axios from 'axios'
import {
	Button,
	Input
} from 'reactstrap'

import QuantitiesActions from '~/actions/quantities.js'

import apiUtils from '~/helper/api.js'


export default class RecipeQuantitiesModalAddEdit extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			btnSubmitDisabled: true,
			quantityAbbrev: props.quantityAbbrev,
			quantity: props.quantity
		}
	}

	componentDidMount() {
		this.setSubmitButtonStatus()
	}

	setSubmitButtonStatus = () => {
		this.setState({
			btnSubmitDisabled: (
				this.state.quantityAbbrev === ''
				|| this.state.quantity === ''
			)
		})
	}

	handleChange = (event) => {
		this.setState(
			{ [event.target.name]: event.target.value },
			this.setSubmitButtonStatus
		)
	}

	submit = () => {
		this.setState({ btnSubmitDisabled: true })

		axios.put(
			`${apiUtils.getApiURL()}/quantities`,
			{
				quantityID: this.props.quantityID,
				quantity: this.state.quantity,
				quantityAbbrev: this.state.quantityAbbrev,
				isActive: 1
			}
		)
			.then(
				() => {
					this.props.cancelFunction()

					// refresh the list
					QuantitiesActions.reload()
				}
			)
	}

	render() {
		const objSubmitButton = {}

		if (this.state.btnSubmitDisabled === true) {
			objSubmitButton.title = 'Enter abbreviation and quantity to enable this button'
		}


		return (
			<tr>
				<td>
					<Input
						name="quantityAbbrev"
						value={this.state.quantityAbbrev}
						onChange={this.handleChange}
						maxLength={8}
					/>
				</td>
				<td>
					<Input
						name="quantity"
						value={this.state.quantity}
						onChange={this.handleChange}
						maxLength={32}
					/>
				</td>
				<td>
					<Button
						onClick={this.submit}
						color="primary"
						disabled={this.state.btnSubmitDisabled}
						block
						{...objSubmitButton}
					>
						Save
					</Button>
				</td>
				<td>
					<Button
						onClick={this.props.cancelFunction}
						color="secondary"
						block
					>
						Cancel
					</Button>
				</td>
			</tr>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/quantities/edit.jsx